/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchProviderLTIDataParser = 
/* #__PURE__ */ parsers.object([
    ['label', /* #__PURE__ */ codecOptional(codecString)],
]);
export class PatchProviderLTIData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchProviderLTIDataParser.decode(input).map(res => new PatchProviderLTIData(res));
    }
    static unsafeDecode(input) {
        return PatchProviderLTIData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchProviderLTIDataParser.encode(data);
    }
    static schema() {
        return PatchProviderLTIDataParser.schema();
    }
}
